<template>
  <a-card :bordered="false">
    <a-button type="primary" v-has:antiWarehousingAdd="()=> {$router.push('/antiFleeingGoods/warehousing/create?type=add')}">
      <PlusOutlined />
      快速入库
    </a-button>
      <a-button class="m-l-10" v-has:intervalStorage="()=> {$router.push('/antiFleeingGoods/warehousing/intervalStorage?type=add')}">
      <PlusOutlined />
      二维码区间入库
    </a-button>
    <a-form class="m-b-20 m-t-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item label="" name='keyword'>
        <a-input-group compact :style="{width:'360px'}">
          <a-select v-model:value="search.keyword_type" style="width: 30%" @change="inputSelect">
            <a-select-option value="warehousing_sn">入库单号</a-select-option>
            <a-select-option value="product_batch">生产批次</a-select-option>
          </a-select>
          <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
        </a-input-group>
      </a-form-item>
      <a-form-item label="创建时间" name='time'>
        <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changTime" />
      </a-form-item>
      <a-form-item label="入库仓库" name='warehouse_id'>
        <a-select v-model:value="search.warehouse_id" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
     <a-form-item label="类型" name='create_type'>
        <a-select v-model:value="search.create_type" :style="{width:'140px'}" placeholder="全部">
          <a-select-option value="">全部</a-select-option>
          <a-select-option value="1">快速入库</a-select-option>
          <a-select-option value="2">按单入库</a-select-option>
          <a-select-option value="3">区间入库</a-select-option>
        </a-select>
      </a-form-item>
       <a-form-item label="商品名称" name='product_name' class="m-t-10">
          <a-input style="width:45%" readonly v-model:value="search.product_name" placeholder='请选择商品'/>
          <a-button type="primary" @click="showGood = true" style="display:inline-block" class="m-r-5">选择</a-button>
          <a-button  @click="search.product_name=[];search.product_id=[];selectList=[]" style="display:inline-block">清除</a-button>
      </a-form-item>
      <a-form-item  class="m-t-10">
        <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
          <a-button type="primary" v-has:antiWarehousingExport="exportTable" class="m-r-10">导出</a-button>
          <a-button  v-has:allBatchEdit="allBatchEdit">批量修改批次</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='warehousing_sn' :columns='columns'  class="tableFixBox" :data-source='list' :scroll="{ x: 'max-content'}">
      <template v-slot:product_name="{ record }">
           <a-card-meta>
            <template #avatar>
              <img :src="info.picdomain+'/'+(record.product_image_url||record.cover_image_url)" alt=""
                style="width:50px;height: 50px;object-fit:cover">
            </template>
            <template #description>   {{record.product_sku_name || '单规格'}} - {{record.product_name}}</template>
          </a-card-meta>
      </template>
      <template #title_num>
        入库数量
      </template>
          <template #real_code_num>
        实际数量
        <a-tooltip placement='right'>
          <template #title>包装的最小单位数量</template>
          <InfoCircleOutlined />
        </a-tooltip>
      </template>
      <template v-slot:realCodeNum="{ record }">
       <P @click="targetId=record.id;codeDetailVisible=true" style="color:#f04635;cursor: pointer;"> {{record.code_num || '-'}}</P>
      </template>
      <template v-slot:action="{ record }">
          <a-button v-has:antiWarehousingDetail="()=>{orderDetailVisible=true;targetId=record.id}" class="m-r-10">查看详情</a-button>
          <a-button v-has:antiWarehousingEdit="()=> {$router.push('/antiFleeingGoods/warehousing/addGoods?type=edit&id='+record.id)}" class="m-r-10" type="primary">添加商品</a-button>
          <a-button v-has:antiWarehousingDel='()=>del(record.id)' danger>删除</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `"/>
  </a-card>
  <!-- 二维码详情 -->
   <a-modal title='入库二维码明细' :keyboard="false" v-model:visible="codeDetailVisible" centered  :width='1300' destroyOnClose :footer='null'>
       <codeDetail :id="targetId"/>
   </a-modal>
   <a-modal title='入库单详情' :keyboard="false" :maskClosable='false' v-model:visible="orderDetailVisible" destroyOnClose :footer='null' :width="800" centered>
    <warehousingDetails  :id="targetId" />
  </a-modal>
    <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1200' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='selectList'  :checkout="true" ></selectGood>
  </a-modal>
   <a-modal :keyboard="false" title="批量修改批次"  v-model:visible="batchVisble" centered :footer="null" :width='1300' destroyOnClose>
     <batchEdit v-on:success="batchVisble=false" />
   </a-modal>
   <!-- 导出 -->
    <a-modal :keyboard="false" title="导出"  v-model:visible="exportVisble" centered :footer="null" :width='500' destroyOnClose>
        <div>
          <div class="s_flex_ali">
            <span>创建时间：</span>
              <a-range-picker v-model:value="exportTime" valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="changExportTime" />
          </div>
          <p style="font-size:14px;color:#999;margin-left:75px" class="m-t-10">导出筛选后的数据，创建时间间距不能大于31天</p>
          <a-button type="primary" class="m-t-40" style="margin-left:50%;transform:translateX(-50%)" @click="exportData">导出</a-button>
        </div>
    </a-modal>
</template>
<script>
  import {PlusOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import store from '@/store'
  import { getWarehouseList,getWarehousing,delWarehousing,exportOrder } from '@/api/antiFleeing';
  import config from '@/config'
  import codeDetail from './components/codeDetail'
  import warehousingDetails from '../components/warehousingDetails.vue'
  import batchEdit from './components/batchEdit.vue';
  import moment from 'moment';
  // 初始化默认筛选项数值
  let defSearch = {
    start_time: "",
    end_time: "",
    warehouse_id: '',
    page: 1,
    limit: 10,
    create_type:'',
    keyword_type: "warehousing_sn",
    keyword: "",
    product_id:[],
    product_name:""
  };
  export default {
    components: {PlusOutlined,InfoCircleOutlined,codeDetail,warehousingDetails,batchEdit},
    setup() {
      const state = reactive({
        selectList:[],
        showGood:false,
        time: [],
        exportTime:[],
        warehouseList:[],
        orderDetailVisible:false,
        exportVisble:false
      });
      let columns = [
        {
          title: "入库单号",
          dataIndex: "warehousing_sn",
          key: "warehousing_sn",
        },
        {
          title: "入库仓库",
          dataIndex: "warehouse_name",
          key: "warehouse_name",
        },
        {
          title: "商品名称",
          dataIndex: "product_name",
          key: "product_name",
          slots: { customRender: "product_name" },
          width:300
        },
        {
          title: "生产批次",
          dataIndex: "product_batch_name",
          key: "product_batch_name",
          customRender:({record})=>{
            return record.product_batch_name ? record.product_batch_name:'-'
          } 
        },
        {
          dataIndex: "warehousing_num",
          key: "warehousing_num",
          slots: { title: 'title_num' }
        },
        {
          dataIndex: "real_code_num",
          key: "real_code_num",
          slots: { title: 'real_code_num',customRender: "realCodeNum" }
        },
           {
          title: "类型",
          dataIndex: "create_type_text",
          key: "create_type_text"
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const $Modal = inject("$Modal");
      
      const changTime = (e) => {
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
        } else {
          message.error(res.msg);
        }
      }
      // 关闭
      const del = (id) => {
        $Modal.confirm({
          centered: true,
          title:'是否删除入库单？',
          onOk: async () => {
            let res = await delWarehousing(id).then((res) => res.data);
            if (iscode(res, true)) {
              tableHoosks.initData(getWarehousing, search.value);
            }
          },
        });
      };
       //选择商品
      const goodSelect = (e) =>{
        console.log(e)
        state.selectList=e
        search.value.product_id=e.map(v=>v.id)
        search.value.product_name=e.map(v=>v.product_name).join()
        // search.value.product_id = [e.id]
        // search.value.product_name =e.product_name
        state.showGood = false
      }
      //导出
      const exportTable=async()=>{
          if(state.time[0]){
             state.exportTime = state.time;
          }else{
            state.exportTime = [moment().subtract(30, 'days'), moment()];
          }
           state.exportVisble = true;
        }
       
       const exportData = async function(){
                let dataNum = moment(state.exportTime[1]).diff(moment(state.exportTime[0]),'days')+1;
                   console.log(dataNum,'天数')
                   if(dataNum>31){
                      message.error('时间间距不能大于31天！')
                   }else{
                       const hide = message.loading('正在加载中...', 0);
                       let result=await exportOrder( { ...search.value, limit: 5000,excel:1,start_time:moment(state.exportTime[0]).format('YYYY-MM-DD'),end_time:moment(state.exportTime[1]).format('YYYY-MM-DD') }).then(res=>res.data).catch(error=>error);
                        setTimeout(hide);
                        if(iscode(result,true)){
                           window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+result.data.key);
                            state.exportVisble = false;
                        }
                   }
       }

      // 二维码详情
      const codeDetailVisible=ref(false)
      const targetId=ref(false)
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        getWarehouse()
        tableHoosks.initData(getWarehousing, search.value);
      });

      const batchEditHooks=function(){
        const batchVisble=ref(false)
        const batchData=ref({})
        const allBatchEdit=function(){
          batchVisble.value=true
        }
        return{
          allBatchEdit,
          batchVisble
        }
      }
      //时间
      const changExportTime = function(e){
           state.exportTime = e;
      }

      return {
        ...toRefs(state),
        ...tableHoosks,
        columns,
        changTime,
        del,
        info: store.state.user.info,
        exportTable,
        codeDetailVisible,
        targetId,
        goodSelect,
        ...batchEditHooks(),
        changExportTime,
        exportData
      };
    },
  };
</script>